import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  const [f, setF] = useState({ name:"", phone:"", email:"", message:"", venue_id: "public" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/inquiries", f);
      toast.success("Thanks! We'll be in touch shortly.");
      setF({ name:"", phone:"", email:"", message:"", venue_id:"public" });
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-2 gap-10">
      <div>
        <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--wine)]">Reach us</div>
        <h1 className="font-display text-5xl">We'd love to plan with you.</h1>
        <p className="text-neutral-700 mt-4">Wedding is a once-in-a-lifetime experience. Reach our concierge team — we help match you with the right venue, catering & decor.</p>
        <div className="mt-6 space-y-3 text-sm">
          <div className="flex items-center gap-3"><Phone className="w-4 h-4"/> +91 98000 00000</div>
          <div className="flex items-center gap-3"><Mail className="w-4 h-4"/> hello@shubhmuhurat.in</div>
          <div className="flex items-center gap-3"><MapPin className="w-4 h-4"/> Bengaluru · Delhi · Mumbai</div>
        </div>
      </div>
      <form onSubmit={submit} className="card-luxury p-6 space-y-3" data-testid="contact-form">
        <input required placeholder="Name" value={f.name} onChange={e=>setF({...f, name:e.target.value})} className="w-full px-3 py-2.5 rounded-lg border" data-testid="contact-name"/>
        <input required placeholder="Phone" value={f.phone} onChange={e=>setF({...f, phone:e.target.value})} className="w-full px-3 py-2.5 rounded-lg border" data-testid="contact-phone"/>
        <input placeholder="Email" value={f.email} onChange={e=>setF({...f, email:e.target.value})} className="w-full px-3 py-2.5 rounded-lg border" data-testid="contact-email"/>
        <textarea required rows={5} placeholder="Tell us about your event" value={f.message} onChange={e=>setF({...f, message:e.target.value})} className="w-full px-3 py-2.5 rounded-lg border" data-testid="contact-message"/>
        <button className="btn-wine w-full justify-center" data-testid="contact-submit">Send message</button>
      </form>
    </div>
  );
}
